import { RefCallback, useCallback, useRef, type RefObject } from 'react';

import { Escape } from '@hh.ru/magritte-common-keyboard/keys';
import { keyboardMatches } from '@hh.ru/magritte-common-keyboard/match';

const handleKeyDown =
    (callbackRef: RefObject<((event: KeyboardEvent) => void) | null | undefined>) => (event: KeyboardEvent) => {
        if (keyboardMatches(event, [Escape])) {
            callbackRef.current?.(event);
        }
    };

export const useEscapeToClose = <T extends HTMLElement = HTMLElement>(
    callback: ((event: KeyboardEvent) => void) | null | undefined
): RefCallback<T> => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    const bindEscapeToCloseRef = useCallback((element: T | null) => {
        if (!element) {
            return;
        }

        element.addEventListener('keydown', handleKeyDown(callbackRef));
    }, []);

    return bindEscapeToCloseRef;
};
